import { lazy, Suspense, type ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import RoleProtectedRoute from "../../router/RoleProtectedRoute";
import { TOP_ROLE_IDS } from "../../hooks/useIsReseller";
import { MENU, MOVIK_BASE, movikDefaultRoute, movikSectionPath } from "./config";

// Movik (categoría B2C): panel interno de operación. Sólo administradores de
// plataforma, misma guardia que Sistemas Internos en WAYAK (RoleProtectedRoute
// con TOP_ROLE_IDS; CC-CONSOLE usa PlatformAdminRoute). Nodo del catálogo:
// app:movik (ruta /b2c/movik; es la misma llave de la antigua app de Sistemas
// Internos de #1535, que hoy es la sección `marca`); la guardia de derechos la
// pone App.tsx a partir del catálogo. Todo se carga bajo demanda.
const MovikLayout = lazy(() => import("./MovikLayout"));

const load = (node: ReactNode) => <Suspense fallback={null}>{node}</Suspense>;

/** A dónde van los enlaces guardados de la app de Sistemas Internos (#1535). */
export const MOVIK_LEGACY_TARGET = movikSectionPath("marca");

/**
 * `/movik` y `/movik/*` eran la app Movik de Sistemas Internos. Redirigen a la
 * sección «Marca y altas» del panel B2C para no romper enlaces guardados; la
 * guardia de plataforma la aplica la ruta destino.
 */
export const movikLegacyRoutes: RouteObject[] = [
  { path: "/movik", element: <Navigate to={MOVIK_LEGACY_TARGET} replace /> },
  { path: "/movik/*", element: <Navigate to={MOVIK_LEGACY_TARGET} replace /> },
];

export const movikRoute: RouteObject = {
  path: MOVIK_BASE,
  element: <RoleProtectedRoute allowedRoleIds={TOP_ROLE_IDS} redirectTo="/apps" />,
  children: [
    {
      element: load(<MovikLayout />),
      children: [
        { index: true, element: <Navigate to={movikDefaultRoute} replace /> },
        ...MENU.map((item) => {
          const Section = item.element;
          return { path: item.id, element: load(<Section />) };
        }),
      ],
    },
  ],
};
